import type { TypeInstances } from './types';

// ----------------------------------------------------------------------------

class InstanceManager<TData = Record<string, any>> {
    readonly #instances: TypeInstances<TData> = new Map();

    has(element: HTMLElement): boolean {
        return this.#instances.has(element);
    }

    get(element: HTMLElement): TData | undefined {
        return this.#instances.get(element);
    }

    add(element: HTMLElement, data: TData): void {
        this.#instances.set(element, data);
    }

    remove(element: HTMLElement): void {
        this.#instances.delete(element);
    }

    purge(): void {
        this.#instances.clear();
    }
}

// ----------------------------------------------------------------------------

export default InstanceManager;
